"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showGreeting = exports.MainPage = void 0;
const local_storage_1 = require("../../utils/local-storage");
const header_1 = require("./header/header");
require("./main-page.scss");
const start_1 = require("./play-board/start");
const logout_modal_1 = require("./template/modal/logout-modal");
class MainPage {
    constructor(id) {
        this.name = (0, local_storage_1.getLogin)().name;
        this.surname = (0, local_storage_1.getLogin)().surname;
        this.page = document.createElement('div');
        this.page.id = id;
        this.header = new header_1.Header('header');
        this.modalLogout = new logout_modal_1.ModalWindow('modal-logout');
        this.playBoard = new start_1.PlayBoardTemplate('play-board');
    }
    createGreetings() {
        const greeting = document.createElement('div');
        const fullname = `${this.name} ${this.surname}`;
        greeting.classList.add('greeting');
        greeting.id = 'greeting';
        greeting.classList.add('greeting-visible');
        greeting.innerText = `Hello, ${fullname}`;
        MainPage.MainPageText.greetingString = `${fullname}`;
        return greeting;
    }
    render() {
        const popup = document.createElement('div');
        popup.classList.add('popup');
        popup.id = 'popup';
        const modalLogout = this.modalLogout.render();
        const container = document.createElement('div');
        container.id = 'mainpage-container';
        this.page.append(this.createGreetings());
        const header = this.header.render(MainPage.MainPageText.greetingString);
        const playBoard = this.playBoard.render();
        container.append(header);
        container.append(playBoard);
        this.page.append(container);
        popup.append(modalLogout);
        this.page.append(popup);
        return this.page;
    }
}
exports.MainPage = MainPage;
MainPage.MainPageText = {
    title: 'RSS Puzzle Game',
    greetingString: ''
};
function showGreeting() {
    setTimeout(() => {
        const greeting = document.getElementById('greeting');
        greeting.classList.remove('greeting-visible');
    }, 1100);
}
exports.showGreeting = showGreeting;
